// Enum for WorkItemTab-Ids
export enum WorkItemTabIds {
    // ID for the WorkItem Object Tab
    WORKITEM_TAB_OBJECT = "e54623b1-eb68-49fd-b94f-33d33893941c"
}